import React from 'react';

const Skills = () => {
    return (
        <section className='mt-28'>
            <div className='md:mx-0 mx-5'>
                <h1 className='text-5xl font-bold text-center' style={{ color: '#65647C' }}>My Skills Set</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-4 mb-10"></hr>
            </div>
            <div className='grid md:grid-cols-2 md:gap-10 gap-1 md:mx-0 mx-5'>
                <div data-aos="fade-left" data-aos-duration="3000">
                    {/* react.js */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">React.js</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "75%" }}></div>
                    </div>
                    {/* node.js */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Node.js</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full" style={{ width: "45%" }}></div>
                    </div>
                    {/* express.js */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Express.js</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "45%" }}></div>
                    </div>
                    {/* mongoDB */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">MongoDB</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "45%" }}></div>
                    </div>
                    {/* html */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">HTML</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "95%" }}></div>
                    </div>
                    {/* ccna */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">CCNA</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "95%" }}></div>
                    </div>
                </div>
                <div data-aos="fade-left" data-aos-duration="3000">
                    {/* Tailwind-CSS */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Tailwind-CSS</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "95%" }}></div>
                    </div>
                    {/* bootstrap */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Bootstrap</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "95%" }}></div>
                    </div>
                    {/* Firebase Authentication */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Firebase Authentication</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "60%" }}></div>
                    </div>
                    {/* next.js */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">Next.js</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "20%" }}></div>
                    </div>
                    {/* css */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">CSS</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "95%" }}></div>
                    </div>
                    {/* mtcna */}
                    <div className="mb-1 text-lg font-semibold text-teal-500 dark:text-yellow-500">MTCNA</div>
                    <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4 dark:bg-gray-700">
                        <div className="bg-gradient-to-r from-red-500 to-blue-500 h-2.5 rounded-full dark:bg-indigo-500" style={{ width: "75%" }}></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;